import React, { useEffect, useState } from 'react';
import AddMantra from './AddMantra';
import Mantras from './Mantras';
import logo from '../../../Images/logo.jpg';
import { useSelector, useDispatch } from 'react-redux';
import { loginData } from '../../../Utils/loginSlice';
import { useNavigate } from 'react-router-dom';
import { toogleReload } from '../../../Utils/reloadSlice';

const MantraSection = ({setEditMantraValue}) => {
  const isReload = useSelector((store) => store.reload.isReload);
  const [mantrasMap, setMantrasMap] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSignOut = () => {
    dispatch(loginData("notexist"));
    navigate('/');
  }

  useEffect(() => {
    getData();
  }, [isReload]);

  const getData = async () => {
    const fetchData = await fetch('https://api.mokx.org/api/v1/mantras');
    const json = await fetchData.json();
    setMantrasMap(json.data.mantras);
  }

  return (
    <>
      <div className={`w-full ${mantrasMap.length === 0 && "h-screen"}`}>
        <div className="w-full py-5 flex flex-col gap-7">
          <div className="flex justify-between">
            <h1 className="text-[#000] text-2xl font-montserrat font-bold">
              Mantras
            </h1>
            <div className='flex gap-5'>
              <div className='bg-clip flex justify-between items-center gap-3 rounded-[20px] px-3 text-[#FFF] cursor-pointer select-none' onClick={() => dispatch(toogleReload())}>
                Reload
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512">
                  <path fill="white" d="M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208s208-93.31 208-208S370.69 48 256 48Zm120 182.15a8.62 8.62 0 0 1-8.62 8.62h-59.54a8.61 8.61 0 0 1-6.09-14.71l22.17-22.17l-5.6-6.51a87.38 87.38 0 1 0-62.94 148a87.55 87.55 0 0 0 82.42-58.25A16 16 0 1 1 368 295.8a119.4 119.4 0 1 1-112.62-159.18a118.34 118.34 0 0 1 86.36 36.95l.56.62l4.31 5l14.68-14.68a8.44 8.44 0 0 1 6-2.54a8.61 8.61 0 0 1 8.68 8.63Z"/>
                </svg>
              </div>
              <div className="w-[40px] h-[40px] pt-[3PX] bg-[#C4C4C4] rounded-full overflow-hidden cursor-pointer" onClick={() => handleSignOut()}>
                <img className='scale-110' src={logo} alt="usericon" />
              </div>
            </div>
          </div>
          <div className="flex flex-wrap gap-9">
            <AddMantra />
            {mantrasMap.map((data) =>
              <Mantras data={data} key={data.id} setEditMantraValue={setEditMantraValue} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default MantraSection;